<div class="content-section">
    <div class="heading-text">{{ headingText }}</div>
    <div class="heading-subtext">{{ headingSubtext }}</div>
    <div class="alert-and-button-container">
        <div class="alert-message">
            <span>{{disabledMessage}}</span>
        </div>
        <div>
            <button mat-raised-button color="primary" (click)="copyToClipboard()" [disabled]="doesNotHaveNpn || isForcedDisabled">
                {{ buttonText }}
            </button>
        </div>
    </div>
    <div class="content-section">
        <div class="button-subtext">{{ buttonSubtext }}</div>
    </div>
</div>